import React, { useState, useEffect } from "react";
import { AllBudgetReport } from "./AllBudgetReport";
import { Select } from "antd";
import { ReportChart } from "./ReportChart";
import downloadIcon from "../../../assets/images/budget/download.png";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const { Option } = Select;
export const AllReportsMain = () => {
  const history = useHistory();
  const budgetReport = useSelector(
    (state) => state.rootReducer.loginUser.budgetReportData
  );
  console.log("budgetReport inall", budgetReport);
  const tags = ["Spreadsheet", "Chart"];
  const [view, setView] = useState("Spreadsheet");
  const handleView = (tag) => {
    setView(tag);
  };
  useEffect(() => {
    if (budgetReport === undefined || budgetReport === null) {
      history.push("/reports/budgetDetails");
    }
  }, []);

  function exportToExcel(data, fileName) {
    const workbook = new ExcelJS.Workbook();
    // const worksheet = workbook.addWorksheet("Sheet 1");

    // this is for hiding gridline from worksheet
    const worksheet = workbook.addWorksheet("Sheet 1", {
      properties: { tabColor: { argb: "FF00FF00" } },
      views: [{ state: "frozen", showGridLines: false }],
    });
    const boldStringRow = worksheet.addRow(["Budget Detail Report"]);
    boldStringRow.font = { bold: true };
    worksheet.addRow([]);

    let startCol = 1; // Starting column for the first table
    const startRow = worksheet.lastRow.number + 1; // Starting row for the first table

    Object.keys(data).forEach((sectionKey, sectionIndex) => {
      const sectionData = data[sectionKey];

      // Add section header
      worksheet.getCell(startRow, startCol).value = sectionKey;
      worksheet.getCell(startRow, startCol).font = { bold: true };

      // Add table headers
      const tableHeaderRow = startRow + 1;
      Object.keys(sectionData[0]).forEach((header, index) => {
        const cell = worksheet.getCell(tableHeaderRow, startCol + index);
        cell.value = header;
        cell.font = { bold: true, name: "Aptos Narrow" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "92d050" },
        };
        worksheet.getColumn(startCol + index).width = 25;
      });

      // Add table data
      sectionData.forEach((item, itemIndex) => {
        const rowData = Object.values(item);
        const row = worksheet.getRow(tableHeaderRow + 1 + itemIndex);
        rowData.forEach((data, colIndex) => {
          const cell = row.getCell(startCol + colIndex);
          cell.value = data;
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          if (colIndex >= 1 && colIndex <= 3) {
            cell.alignment = { horizontal: "center" };
          }
        });
      });

      // Move to the next column for the next table
      startCol += Object.keys(sectionData[0]).length + 1;
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName);
    });
  }

  // function for formating data for excel sheet required format for given transactions we have to give it transactions data
  function transformData(data) {
    const result = {
      Category: [],
    };

    // Helper function to format date to month and year
    function getMonth(date) {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const d = new Date(date);
      return monthNames[d.getMonth()] + " " + d.getFullYear();
    }

    // Sum amounts by category
    const categoryMap = new Map();
    data.forEach((item) => {
      const category = item.categoryFromPlaid || "Unknown";
      if (categoryMap.has(category)) {
        categoryMap.set(category, categoryMap.get(category) + item.amount);
      } else {
        categoryMap.set(category, item.amount);
      }
    });

    categoryMap.forEach((amount, category) => {
      result.Category.push({ Category: category, Amount: amount.toFixed(2) });
    });

    // Group items by month and sum amounts by itemName and bankName
    data.forEach((item) => {
      const month = getMonth(item.date);
      if (!result[month]) {
        result[month] = [];
      }
      const existingItem = result[month].find(
        (entry) => entry[`Item Name`] === item.itemName
      );
      if (existingItem) {
        existingItem.Amount += item.amount;
      } else {
        result[month].push({
          "Item Name": item.itemName,
          // bankName: item.bankName,
          Amount: item.amount,
        });
      }
    });
    // Format amounts in month groups with dollar sign
    Object.keys(result).forEach((key) => {
      if (key !== "Category") {
        result[key] = result[key].map((item) => ({
          ...item,
          Amount: `${item.Amount.toFixed(2)}`,
        }));
      }
    });
    return result;
  }

  // Example usage
  const transformedData = budgetReport && transformData(budgetReport);
  console.log("transformedData", transformedData);

  return (
    <div className="BudgetReportMain">
      <div className="budgetSection">
        <div className="addTitle">All Budget Details </div>
        <div className="budgetDetails" style={{ gap: "1rem" }}>
          <button
            className="exportButton"
            onClick={() => {
              exportToExcel(
                transformedData && transformedData,
                "budgetReport.xlsx"
              );
              // setCategoryModal(true);
            }}
          >
            {" "}
            Export{" "}
            <img src={downloadIcon} height={22} width={22} alt="icon"></img>
          </button>
          <div className="filterIcons">
            <Select
              showSearch
              style={{ width: 200, outline: "none", border: "none" }}
              placeholder="Select Filter"
              value={view && view}
              onChange={(value, id) => {
                console.log("value", value);
                handleView(value);
              }}
            >
              {tags &&
                tags.map((item, index) => (
                  <Option key={index} value={item}>
                    {item}
                  </Option>
                ))}
            </Select>
          </div>
        </div>
      </div>
      {view && view === "Spreadsheet" && <AllBudgetReport />}
      {view && view === "Chart" && <ReportChart />}
    </div>
  );
};
